import { STATE_STATUSES } from '@nv/utils'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import styles from './EventStateStatus.module.scss'

export const EventStateStatus = ({ eventStatus }: any) => {
  const { t } = useTranslation()

  const getColorClassTag = ({ eventStatus }) => {
    if (eventStatus === STATE_STATUSES.active || eventStatus === STATE_STATUSES.nominationStarted) return '--success'
    if (eventStatus === STATE_STATUSES.upcoming || eventStatus === STATE_STATUSES.nominationUpcoming) return '--warning'
    return '--error'
  }

  return (
    <span className={clsx(styles['text'], styles[`text${getColorClassTag({ eventStatus })}`])}>
      {t(`events.statusLabel.${eventStatus}`)}
    </span>
  )
}
